<template>
    <div>
        <Sidebar :drawer="$store.state.drawer"></Sidebar>
        <Header :drawer="$store.state.drawer"></Header>
    </div>
</template>

<script>
    import axios from "axios";
    import Sidebar from "../shared/Sidebar";
    import Header from "../shared/Header";

    export default {

        components: {
            Sidebar: Sidebar,
            Header: Header,
        },
        methods: {
            showModal() {
                this.$swal("", "VUNET Result \n<br> Result of Vishwakarma University National Entrance Test (VUNET) is normally announced within 7 working days. The same is communicated to Individual Candidate on registered email.\n<br> The result is communicated as <b>“Qualified” / “Not Qualified”</b>. Qualified students are suggested to approach Counselling and Admissions Office on priority to proceed with Admission.\n<br>In case of any query, email us on (entrance.exam@vupune.ac.in) or contact us on 8669908324 / 9011059478", "success");
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            }
        },
        mounted() {
            this.showModal();
        }


    };
</script>